import { Paths } from '../../types/api'
import { mapUserRoleIDToEnum, setAccountState, setDate, setWithdrawalState } from '../../utils/helpers'
import { ICurrentUserLoadDetailPayload } from './currentUserActions'

export const mapCurrentUserLoadDetailResponse = (
	payload: Paths.GetApiV1UsersUserId.Responses.$200
): Omit<ICurrentUserLoadDetailPayload, 'isLoading' | 'isFailure'> => {
	const {
		employee: {
			userID,
			role: { roleID },
			email,
			firstName,
			lastName,
			company,
			bankData,
			availableEarnings,
			startOfPeriod,
			endOfPeriod,
			nextPayDate,
			userStatus,
			confirmedAt,
			currentWithdrawal,
			registrationEmailSentAt,
			availableEarningsUpdatedAt,
			integrationStatus,
			contracts
		}
	} = payload

	return {
		record: {
			id: userID,
			role: mapUserRoleIDToEnum(roleID),
			email: email,
			firstName: firstName,
			lastName: lastName,
			company: company || null,
			bankData: bankData,
			availableEarnings: availableEarnings || 0,
			periodStartDate: setDate(startOfPeriod),
			periodEndDate: setDate(endOfPeriod),
			nextPayDate: setDate(nextPayDate),
			accountState: setAccountState(userStatus),
			activationDate: setDate(confirmedAt),
			withdrawalID: currentWithdrawal?.withdrawalID,
			withdrawalState: setWithdrawalState(currentWithdrawal?.status),
			withdrawalAmount: currentWithdrawal?.amount,
			invitationEmailSentAt: setDate(registrationEmailSentAt),
			availableEarningsUpdatedAt: setDate(availableEarningsUpdatedAt),
			integrationStatus: integrationStatus,
			contracts: contracts || []
		}
	}
}
